import React from 'react';

/*
  What a domain still needs (plan: stage 3, item 5): ownership (TXT) and
  routing (A / CNAME) after the last Verify. The server sends codes; the
  sentences live here so they are translated like the rest of the interface.
*/

export function domainTxtHint(t, code, host) {
  switch (code) {
    case 'txt_missing':
      return t('Ownership not confirmed: there is no TXT record _xpnsr-verify.{host} yet. Add it at your DNS provider; updates can take up to 24 hours.', { host });
    case 'txt_mismatch':
      return t('Ownership not confirmed: the TXT record _xpnsr-verify.{host} exists but holds another value. Copy the value from this card.', { host });
    case 'dns_error':
      return t('The DNS check did not answer. Try Verify again in a few minutes.');
    default:
      return null;
  }
}

export function domainRoutingHint(t, d) {
  const expected = d.routing_expected || {};
  const found = (d.routing_found || []).join(', ') || '—';
  switch (d.routing_code) {
    case 'routing_ok':
      return t('The domain points to the tracker.');
    case 'routing_missing':
      return t('The domain does not point anywhere yet: add the routing record from this card ({type} → {value}).', {
        type: expected.type,
        value: expected.value,
      });
    case 'routing_wrong':
      return t('The domain points elsewhere ({found}). Change the routing record to {type} → {value}, otherwise links on this domain do not open.', {
        found,
        type: expected.type,
        value: expected.value,
      });
    case 'dns_error':
      return t('The DNS check did not answer. Try Verify again in a few minutes.');
    default:
      return null;
  }
}

export default function DomainCheckHints({ d, t }) {
  if (!d || !t) return null;
  const txt = d.status !== 'verified' ? domainTxtHint(t, d.last_error_code, d.hostname) || d.last_error : null;
  const routing = domainRoutingHint(t, d);
  if (!txt && !routing) return null;
  return (
    <div className="mt-1 space-y-0.5 text-xs" data-testid={`domain-hints-${d.id}`}>
      {txt ? <p className="text-destructive">{txt}</p> : null}
      {routing ? <p className={d.routing_ok ? 'text-muted-foreground' : 'text-destructive'}>{routing}</p> : null}
    </div>
  );
}
